import { SvgIcon, SvgIconProps } from "@mui/material";

export function AutobahnIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M10,2 L8,8 L11,8 L11,2 L10,2 M13,2 L13,8 L16,8 L14,2 L13,2 M2,9 L2,10 L4,10 L4,11 L6,11 L6,10 L18,10 L18.06,11 L20,11 L20,10 L22,10 L22,9 L2,9 M7,11 L3.34,22 L11,22 L11,11 L7,11 M13,11 L13,22 L20.66,22 L17,11 L13,11 Z" />
    </SvgIcon>
  );
}
